/**
 * @generated SignedSource<<1b47ef895340c2d3bc28eef20f615c53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedDetailFramingOptions_user";
};
export type PdpSharedDetailFramingOptions_user$key = {
  readonly " $data"?: PdpSharedDetailFramingOptions_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cca59e9c3fb17cd1c91d7779951003f1";

export default node;
